import React from 'react';
import {useParams} from 'react-router-dom';
import {useQuery} from '@apollo/client';
import {LoadingPage} from '../../components/loading-page';
import {FIND_BY_ID_ORCAMENTO} from '../../graphql/queries';
import FormularioPedido from './formulario';

const EditarPedido = () => {
  const {pedidoId} = useParams();

  const pedidoQuery = useQuery(FIND_BY_ID_ORCAMENTO, {
    variables: {
      id: pedidoId,
    },
  });

  const pedido = pedidoQuery?.data?.orcamento;

  const refetch = () => {
    pedidoQuery.refetch();
  };

  return pedidoQuery.loading || pedidoQuery.error ? (
    <LoadingPage loading={pedidoQuery.loading} error={pedidoQuery.error} />
  ) : (
    <FormularioPedido pedido={pedido} refetch={refetch} />
  );
};

export default EditarPedido;
